var path = '/app/pages/projects/projects.html';
var html = " <div class=\"container projects-heading-container pt-md-5 pb-md-3 pt-4\"> <div class=row> <div class=\"col projects-heading\"> <h1 class=display-4>Projects</h1> <div class=project-meta> <p>Viewing {{ ctrl.projects.length }} of {{ ctrl.totalProjectCount }} projects</p> </div> </div> </div> </div> <div class=\"container projects-container py-4\"> <project-list-item data=project ng-repeat=\"project in ctrl.projects\"></project-list-item> <div ng-if=\"ctrl.projects.length == 0\" class=text-center style=\"padding:6.5rem 0\"> <p>We couldn't find any live projects at the moment...<br> Please check back at a later date.</p> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/projects/projects.html
// module id = 489
// module chunks = 0